<template>
  <li class="nav-item">
    <a class="nav-link" href="/">BERANDA</a>
  </li>
  <li class="nav-item dropdown position-relative">
    <a
      class="nav-link dropdown-toggle"
      href="javascript:void(0)"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      LAYANAN
    </a>
    <div class="dropdown-menu">
      <a
        class="dropdown-item"
        href="/layanan-permohonan-daya"
        style="font-size: 14px !important"
        >Dukungan Daya Sementara</a
      >
      <a
        class="dropdown-item"
        href="/layanan-iuptl"
        style="font-size: 14px !important"
        >Pelaporan IUPTLS/IUPTLU/IUJPTL</a
      >
      <a
        class="dropdown-item"
        href="/layanan-suket"
        style="font-size: 14px !important"
        >Permohonan Surat Keterangan</a
      >
    </div>
  </li>
  <li class="nav-item">
    <a class="nav-link" href="/sebaran-spklu">PETA SPKLU</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" href="/peraturan">PERATURAN</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" href="/faqs">FAQ</a>
  </li>
  <li class="nav-item" v-if="!authStore.isAuthenticated">
    <a
      href="/login"
      class="nav-link btn btn-warning btn-sm bg-custom w-100 fw-bold"
    >
      <strong> Masuk / Daftar </strong></a
    >
  </li>
  <li class="nav-item dropdown position-relative" v-else>
    <a
      class=""
      href="javascript:void(0)"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <img
        :src="
          profileData.avatar == null
            ? '/fe/asset/img/user-profile.png'
            : getFilePath('user-profile', profileData.avatar)
        "
        style="max-width: 45px; cursor: pointer;box-fit: cover;object-fit: cover;object-position: center;"
        class="mt-3 mb-3 ml-2 cursor-pointer dropdown-toggle rounded-circle"
        alt=""
      />
    </a>
    <div class="dropdown-menu">
      <a class="dropdown-item" href="javascript:void(0)" @click="goToDashboard"
        >Dashboard</a
      >
      <a class="dropdown-item" href="javascript:void(0)" @click="goToProfile"
        >Profil</a
      >
      <a class="dropdown-item" href="javascript:void(0)" @click="logout"
        >Keluar</a
      >
    </div>
  </li>
  <li class="nav-item mr-5"></li>
</template>

<script lang="ts">
import { getFilePath } from "@/core/helpers/assets";
import { defineComponent, onMounted, reactive, ref } from "vue";
import { useAuthStore } from "@/store/auth";
import JwtService from "@/core/services/JwtService";

export default defineComponent({
  name: "Menu",
  setup() {
    const authStore = useAuthStore();
    const userData = authStore.user;
    const isLoading = ref(false);

    const logout = async () => {
      await authStore.logout();
      // window.location.reload();
    };

    const goToDashboard = () => {
      if (authStore.isAuthenticated) {
        const rediirectAdmin =
          process.env.VUE_APP_ADMIN_URL_REDIRECT + JwtService.getToken();
        window.location.href = rediirectAdmin;
      } else {
        window.location.href = "/login";
      }
    };

    const goToProfile = () => {
      if (authStore.isAuthenticated) {
        const rediirectAdmin =
          process.env.VUE_APP_ADMIN_URL_REDIRECT +
          JwtService.getToken() +
          "&page=profile";
        // console.log(rediirectAdmin);
        window.location.href = rediirectAdmin;
      } else {
        window.location.href = "/login";
      }
    };

    const profileData = reactive({
      avatar: "",
    });
    const getProfile = async () => {
      if (authStore.isAuthenticated) {
        await authStore.getProfile().then((res) => {
          profileData.avatar = res.data.data.avatar;
        });

        // console.log(profileData.avatar);
      }
    };

    onMounted(async () => {
      // console.log(authStore.isAuthenticated);
      if (authStore.isAuthenticated) {
        isLoading.value = true;
        await getProfile();
        isLoading.value = false;
        // console.log(profileData.avatar);
      }
    });

    return {
      authStore,
      logout,
      goToDashboard,
      userData,
      getFilePath,
      goToProfile,
      profileData,
    };
  },
});
</script>
